var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSmile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4263 6.60043C30.7196 11.8938 30.6263 20.5337 25.1596 25.7204C20.1063 30.5071 11.9063 30.5071 6.83962 25.7204C1.35962 20.5337 1.26627 11.8938 6.57294 6.60043C11.7729 1.3871 20.2263 1.3871 25.4263 6.60043Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1192 21.4277C18.2926 24.0944 13.7059 24.0944 10.8926 21.4277",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSmile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/smile.41977a19.svg";
export { ForwardRef as ReactComponent };